import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BookingRefundActionModel extends Model {
  @attr('number') amount!: number;

  @belongsTo('payment', { inverse: null, async: false })
  payment!: ModelRegistry['payment'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'booking-refund-action': BookingRefundActionModel;
  }
}
